<div class="account-deletion-container">
	<h3>{{'account_deletion.title' | translate}}</h3>
	<p>{{'account_deletion.intro' | translate}}</p>

	<h4>{{'account_deletion.steps_title' | translate}}</h4>
	<ol>
		<li>{{'account_deletion.step1' | translate}}</li>
		<li>{{'account_deletion.step2' | translate}}</li>
		<li>{{'account_deletion.step3' | translate}}</li>
		<li>{{'account_deletion.step4' | translate}}</li>
		<li>{{'account_deletion.step5' | translate}}</li>
	</ol>

	<h4>{{'account_deletion.after_title' | translate}}</h4>
	<p>{{'account_deletion.after_body' | translate}}</p>

	<h4>{{'account_deletion.retention_title' | translate}}</h4>
	<p>{{'account_deletion.retention_body' | translate}}</p>

	<div class="notice-box">
		<strong>{{'account_deletion.important_label' | translate}}</strong> {{'account_deletion.important_body' | translate}}
	</div>

	<p class="support-note">{{'account_deletion.support_note' | translate}}</p>
</div>
